import React, { Component } from 'react';

class Form extends Component {
    render(){
        return (
            <div className="chat-form">
                <input
                 value={this.props.text}
                 onChange={this.props.onChange}
                 />
                 <button
                  ref='input'
                  onClick={this.props.onCLick}
                 >
                     SEND 
                 </button>
            </div>
        )
    }
}

export default Form;


// WEBPACK FOOTER //
// ./src/components/chat/Form.js